var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_vm._m(0),_c('router-view',{staticClass:"box"}),_c('Updata')],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"bg-layer",attrs:{"aria-hidden":"true"}},[_c('span',{staticClass:"blob blob-1"}),_c('span',{staticClass:"blob blob-2"}),_c('span',{staticClass:"blob blob-3"})])
}]

export { render, staticRenderFns }